import React from 'react';
import { connect } from 'react-redux';
import { Card, Table, Button, Header, Icon, Modal, Image, Popup, Responsive, Segment, Grid, TextArea } from 'semantic-ui-react';
import { round as _round, find as _find, join as _join, keyBy as _keyBy } from 'lodash';
import './ProjectsBids.less';

import { WIN_BID_DELTA } from '../../constants/Bid';

import TimeCountDown from '../TimeCountDown/TimeCountDown';
import Pagination from '../Pagination/Pagination';
import PhotoSlideShow from '../PhotoSlideShow/PhotoSlideShow';

import { placeBid, toggleRequestPin as _toggleRequestPin, toggleServicePin as _toggleServicePin, getSBRImages, getSbrBidsHistory } from '../../services/Project';

import { showNotificationMessage } from '../../store/actions/reactNotification'
import { clearLostNotification } from '../../store/actions/notifications';
import { refreshSellerServices } from '../../store/actions/seller';

import { SUCCESS, ERROR } from '../../constants/NotificationType';
import { priceDisplay } from '../../helpers/price';

import BidHistory from '../BidHistory/BidHistory';
import PlaceBidContainer from '../../containers/PlaceBidContainer/PlaceBidContainer';
import PlaceBidContainerNew from '../../containers/PlaceBidContainerNew/PlaceBidContainerNew';

import moment from 'moment';
import { requestMoreInfo } from '../../services/Seller';
import DGTextarea from '../FormControls/Textarea/DGTextarea';
import Formsy from 'formsy-react';
import DisplayDistanceNew from '../../components/DisplayDistanceNew/DisplayDistanceNew';

class ProjectsBids extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            winningBid: {},
            winningBidAmount: 0,
            collapsed: true,
            loading: false,
            rowsPerPage: 10,
            activePage: 1,
            requests: [],
            requestsCount: 0,
            openedImageIndex: -1,
            slideShowImages: [],
            bidHistory: [],
            historyModalOpen: false,
            currentSellerBid: null,
            currentServiceName: '',
            currentQuickInfo: '',
            //,showDetails: true
            requestIdForDetails: 0,
            detailsModalOpen: false,
            contactUsDetails: {},
            isMoreInfoModalOpen: false,
            sellerInfoRequestMessage: ''
        }
    }

    async componentDidMount() {
        this.refreshServiceBids();
    }
    winBid = async (request) => {
        const { service } = this.props;
        const winningBidAmount = request.bid.minBid && _round(request.bid.minBid - WIN_BID_DELTA, 2) || service.priceMax;
        await this.setState({ open: true, winningBid: request, winningBidAmount });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.visitTime !== this.props.visitTime) {
            this.refreshServiceBids();
        }
    }
    confirmWinBid = async () => {
        const { winningBid, winningBidAmount } = this.state;
        placeBid(winningBid.sbr.singleBuyerRequestID, { bidPrice: winningBidAmount })
            .then(() => {
                this.props.showNotificationMessage('Bid placed successfully.');
                this.setState({ open: false });
                this.refreshServiceBids();
            })
            .catch(() => {
                console.log('failed');
                this.props.showNotificationMessage(ERROR, 'Bid placing failed.');
            });
    }

    toggleRequestPin = async (request) => {
        const { singleBuyerRequestID } = request.sbr;
        _toggleRequestPin(singleBuyerRequestID)
            .then((res) => {
                this.props.showNotificationMessage(SUCCESS, res && res.message || 'Pin toggled successfully.');
                this.refreshServiceBids();
            })
            .catch(() => {
                this.props.showNotificationMessage(ERROR, 'Pin toggle failed.');
            });
    }

    toggleServicePin = async () => {
        const { service } = this.props;
        _toggleServicePin(service.serviceID)
            .then((res) => {
                const servicePinID = res.data && res.data.servicePinID || null;
                this.props.onTogglePin && this.props.onTogglePin(servicePinID);
                this.props.showNotificationMessage(SUCCESS, res && res.message || 'Service pin toggled successfully.');
                this.props.refreshSellerServices();
            })
            .catch(() => {
                this.props.showNotificationMessage(ERROR, 'Service pin toggle failed.');
            });
    }

    get isPinnedService() {
        const { service } = this.props;
        return !!service.servicePinID;
    }
    async onPageChange(e, d) {
        await this.setState({ activePage: d.activePage });
        this.refreshServiceBids();
    }

    refreshServiceBids = async () => {
        this.setState({ loading: true });
        const { service, winningBids } = this.props;
        const { rowsPerPage, activePage } = this.state;
        const options = {
            serviceID: service.serviceID,
            limit: rowsPerPage,
            page: activePage
        }
        const res = await this.props.getRequests(options);
        if (res.resStatus == 400) {
            this.props.history.push('/business/signup');
        }
        const { requests, count } = res.data;

        this.setState({ requests, requestsCount: count[0] && count[0].count || 0, loading: false });
        if (!winningBids) {
            this.props.clearLostNotification(service.serviceID);
        }
    }

    close = () => {
        this.setState({ open: false })
    }

    isWinner = (bid) => {
        const { currentUser } = this.props;
        return currentUser.Seller && currentUser.Seller.sellerID && currentUser.Seller.sellerID === bid.winnerID;
    }

    calculateDelta = (bid) => {
        const { minBid, sellerBid } = bid;
        if (this.isWinner(bid) || !minBid && !sellerBid) {
            return 0;
        } else if (!this.isWinner(bid)) {
            return Math.abs(_round((bid.sellerBid || 0) - (bid.minBid || 0), 2));
        }
        return 0;
    }

    hasNotification = (service) => {
        const { added, updated, lost } = this.props;
        const all = [...added, ...updated, ...lost];
        const keyAll = _keyBy(all, 'serviceID');
        return !!keyAll[service.serviceID];
    }

    startSlideShow = async ({ singleBuyerRequestID }) => {
        try {
            const images = await getSBRImages(singleBuyerRequestID).then(res => res.data);
            this.setState({ openedImageIndex: 0, slideShowImages: images });
        } catch (error) {
            console.log(error);
            this.setState({ openedImageIndex: -1, slideShowImages: [] });
        }
    }

    renderDetails = () => {

        if (this.props.hideDetails) {
        }
        else {
            return (
                <Table.Cell width="1">
                    <Button size="tiny" positive onClick={() => this.props.history.push(`requests/${request.sbr.singleBuyerRequestID}/details/`)}>DETAILS</Button>
                </Table.Cell>
            )
        }
    }

    showBidHistory = async (sbrId, bid, service, sbr) => {
        const bidHistory = await getSbrBidsHistory(sbrId);
        console.log('showBidHistory', bidHistory)
        if (bidHistory && bidHistory.resStatus === 200 && bidHistory.data && !_.isEmpty(bidHistory.data)) {
            this.setState({
                bidHistory: bidHistory.data || [], historyModalOpen: true,
                currentSellerBid: bid.sellerBid,
                currentServiceName: service.name,
                currentQuickInfo: sbr.quickInfo
            });
            return;
        }

        this.setState({ historyModalOpen: true });
    }

    historyModalClose = () => {
        this.setState({ historyModalOpen: false, bidHistory: [], currentSellerBid: null, currentQuickInfo: '', currentServiceName: '' });
    }

    onDetailsButtonClick = (sbrId) => {
        this.setState({ requestIdForDetails: sbrId, detailsModalOpen: true })
    }

    onDetailsModalClose = () => {
        this.setState({ requestIdForDetails: 0, detailsModalOpen: false })
    }

    afterBidPlaced = () => {
        this.refreshServiceBids();
        this.onDetailsModalClose();
    }
    onRequetInfoSubmit = async () => {
        await requestMoreInfo({
            ...this.state.contactUsDetails,
            Question: this.state.sellerInfoRequestMessage,
            subject: 'More Info Request',
        });
        this.setState({ isMoreInfoModalOpen: false })
    }

    onMoreInfoClick = (e, data) => {
        e.preventDefault();
        this.setState({
            contactUsDetails: {
                SellerPhone: this.props.currentUser.Seller.cellPhone,
                SellerName: this.props.currentUser.Seller.name,
                SellerEmail: this.props.currentUser.Seller.email,
                ServiceName: data.service.name,
                serviceID: data.service.serviceID,
                RequestID: data.sbr.singleBuyerRequestID
            },
            isMoreInfoModalOpen: true
        })
    }

    render() {
        const { service, winningBids } = this.props;
        const { requests, requestsCount, rowsPerPage, activePage, loading, open, winningBidAmount, collapsed, openedImageIndex, slideShowImages, historyModalOpen, bidHistory, currentSellerBid, requestIdForDetails, detailsModalOpen } = this.state;

        if (!requests.length) {
            return null;
        }
        return (
            <Card fluid className="ProjectsBids">
                <Card.Content>
                    <Header as="h1" floated="left">{service.name}</Header>
                    {this.hasNotification(service) && <Icon loading size="small" color="red" style={{ position: "fixed" }} name="certificate"></Icon> || null}
                    <div style={{ float: 'right' }}>
                        <Popup content={this.isPinnedService ? 'Remove service from dashboard.' : 'Pin service to dashboard.'} trigger={<Icon name={this.isPinnedService ? 'cut' : 'pin'} onClick={() => this.toggleServicePin()} />} />
                        <Popup content={collapsed ? 'Collapse requests.' : 'Expand requests.'} trigger={<Icon name={collapsed ? 'angle up' : 'angle down'} onClick={() => this.setState({ collapsed: !collapsed })} />} />
                        <Popup content='Click to refresh requests.' trigger={<Icon name='refresh' loading={loading} onClick={this.refreshServiceBids} />} />
                    </div>
                </Card.Content>
                {collapsed && (<Card.Content>
                    <Table striped>
                        {window.innerWidth >= 768 &&
                            <Table.Header>
                                <Table.Row >
                                    {
                                     !this.props.showDistanceWidget &&
                                        <Table.HeaderCell 
                                        style={{width: '170px'}}
                                        ></Table.HeaderCell>
                                    }
                                    

                                    {/* <Table.HeaderCell style={{width: '120px'}}>Request #</Table.HeaderCell> */}
                                    {/* {!winningBids && <Table.HeaderCell width="1"></Table.HeaderCell>} */}
                                    {/* {!winningBids && <Table.HeaderCell width="2"></Table.HeaderCell>} */}
                                    {/*<Table.HeaderCell width={3}>Expires</Table.HeaderCell>*/}
                                    {/* <Table.HeaderCell width={2}>Your Quote</Table.HeaderCell> */}
                                    {/* <Table.HeaderCell>Quick Info</Table.HeaderCell> */}
                                    <Table.HeaderCell> {(service.quickInfoColumnHeading && service.quickInfoColumnHeading.length > 0)
                                     ? service.quickInfoColumnHeading : "Quick Info"} </Table.HeaderCell>

                                     {
                                         this.props.showDistanceWidget && <Table.HeaderCell 
                                        //  style={{width: '170px'}}
                                         ></Table.HeaderCell>
                                     }
                                    <Table.HeaderCell>Photo(s)</Table.HeaderCell>
                                    {/* <Table.HeaderCell style={{width: '110px'}}></Table.HeaderCell> */}
                                </Table.Row>
                            </Table.Header>
                        }

                        <Table.Body>
                            {requests.map((request, i) => {
                                return (
                                    <Table.Row key={`bids_${i}`}>
                                        {   /* { 
                                            this.renderDetails()
                                            } */
                                        }
                                        {
                                            window.innerWidth >= 768 && !this.props.showDistanceWidget &&
                                            <Table.Cell width={3} style={{ display: 'table-cell', minWidth: '170px' }}>
                                                {(<Button size="tiny" className="large ui primary button" style={{ fontSize: '0.9em' }}  onClick={() => this.onDetailsButtonClick(request.sbr.singleBuyerRequestID)}>Quote Now</Button>)}
                                                {/* {(<Button size="tiny" className="primary-button action-button" style={{ fontSize: '0.8em' }} onClick={() => this.showBidHistory(request.sbr.singleBuyerRequestID, request.bid, request.service, request.sbr)}>QUOTE HISTORY</Button>)} */}
                                            </Table.Cell>
                                        }
                                        
                                        {/* <Table.Cell width={1} style={{ "color": window.innerWidth > 480 ? "" : '' }}>

                                            {
                                                window.innerWidth <= 480 &&
                                                <React.Fragment>
                                                    <div style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                                                        <div style={{ paddingBottom: '2px' }}>
                                                            <b>Request #:</b>
                                                        </div>
                                                        <div >
                                                            {request.sbr.singleBuyerRequestID}
                                                        </div>
                                                    </div>
                                                </React.Fragment>

                                            }
                                            {
                                                window.innerWidth > 480 && `${request.sbr.singleBuyerRequestID}`
                                            }

                                        </Table.Cell> */}
                                        {/* {!winningBids && <Table.Cell width="3"> */}
                                        {/* {!this.isWinner(request.bid) && (<Button size="tiny" positive onClick={() => this.winBid(request)}>BID LOWEST PRICE</Button>)} */}
                                        { /*<Button size="tiny" positive onClick={() => this.toggleRequestPin(request)}>{request.pin && request.pin.sbrPinID ? 'Unpin' : 'Pin'}</Button> */}
                                        {/* </Table.Cell>} */}
                                        {/* <Table.Cell width={2}>
                                            {
                                                window.innerWidth <= 480 &&
                                                <React.Fragment>
                                                    <div style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                                                        <div style={{ paddingBottom: '2px' }}>
                                                            <b>Your Quote:</b>
                                                        </div>
                                                        <div>
                                                            {request.bid.sellerBid && priceDisplay(request.bid.sellerBid) || 'N/A'}
                                                        </div>
                                                    </div>
                                                </React.Fragment>

                                            }
                                            {
                                                window.innerWidth > 480 &&
                                                `${request.bid.sellerBid && priceDisplay(request.bid.sellerBid) || 'N/A'}`
                                            }
                                        </Table.Cell> */}
                                        <Table.Cell width={this.props.showDistanceWidget ? 1 : ""} 
                                        style={{minWidth: (this.props.showDistanceWidget && window.innerWidth > 768 )? "628px" : "unset"}}
                                        >
                                            {
                                                window.innerWidth <= 768 &&
                                                <React.Fragment>
                                                    <div style={{ paddingTop: '5px', paddingBottom: '5px' }}>
                                                        <div style={{ paddingBottom: '2px' }}>
                                                            <b>{(service.quickInfoColumnHeading && service.quickInfoColumnHeading.length > 0)
                                                            ? service.quickInfoColumnHeading : "Quick Info"}:</b>
                                                        </div>
                                                        {
                                                            request.sbr.postProcessing && this.props.showDistanceWidget ? 
                                                            <>
                                                                <div className={"container distance mobile"}>
                                                                    <DisplayDistanceNew showViewLink={false} sbr={request.sbr} ></DisplayDistanceNew>                                                      
                                                                </div>
                                                                <div className={"container quickInfo mobile"}>
                                                                    {request.sbr.quickInfo}
                                                                </div>
                                                            </>
                                                        : 
                                                            <div>
                                                                {request.sbr.quickInfo}
                                                            </div>
                                                        } 
                                                    </div>
                                                </React.Fragment>
                                            }
                                            {
                                                window.innerWidth > 768 &&
                                                <>
                                                {
                                                    request.sbr.postProcessing && this.props.showDistanceWidget ? 
                                                    <>
                                                        <div className={"container quickInfo"}>
                                                            {request.sbr.quickInfo}
                                                        </div>  
                                                        <div className={"container distance"}>
                                                            <DisplayDistanceNew showViewLink={false}  sbr={request.sbr} ></DisplayDistanceNew>                     
                                                        </div>     
                                                    </>
                                                    
                                                : 
                                                    <div>
                                                        {request.sbr.quickInfo}
                                                    </div>
                                                }
                                                </>
                                            }
                                        </Table.Cell>
                                        {
                                            window.innerWidth >= 768 && this.props.showDistanceWidget &&
                                            <Table.Cell width={2}
                                            // style={{ display: 'table-cell', minWidth: '170px' }}
                                            >
                                                {(<Button size="large" className={`large ui primary button large-button ${request.sbr.postProcessing ? "" : "quick-info"}`} style={{ fontSize: '0.9em' }}  onClick={() => this.onDetailsButtonClick(request.sbr.singleBuyerRequestID)}>Quote Now</Button>)}
                                            </Table.Cell>
                                        }
                                        <Table.Cell>
                                            <div>
                                                {request.image && request.image.URL && (
                                                    <Image
                                                        src={`${request.image.URL}`}
                                                        size='tiny'
                                                        className="service-request-thumb"
                                                        onClick={() => this.startSlideShow(request.sbr)}
                                                    />
                                                )}
                                            </div>
                                        </Table.Cell>


                                        {
                                            window.innerWidth < 768 &&
                                            <Table.Cell width={3} style={{ display: 'block', minWidth: '170px' }}>
                                                {(<Button size="tiny" className="large ui primary button large-button quick-info" style={{ fontSize: '0.9em' }} onClick={() => this.onDetailsButtonClick(request.sbr.singleBuyerRequestID)}>Quote Now</Button>)}
                                            </Table.Cell>
                                        }

                                        {/* <Table.Cell>
                                            <button onClick={(e) => this.onMoreInfoClick(e, request)} class="large ui primary button">
                                                More Info
                                            </button>
                                        </Table.Cell> */}
                                    </Table.Row>
                                )
                            })}
                            <PhotoSlideShow images={slideShowImages} openedImageIndex={openedImageIndex} setOpenedIndex={(idx) => this.setState({ openedImageIndex: idx })} />
                        </Table.Body>
                    </Table>

                    <Pagination activePage={activePage} totalPages={requestsCount && requestsCount / rowsPerPage || 1} disabled={loading}
                        onPageChange={(e, d) => this.onPageChange(e, d)}
                    />

                    <Modal size='mini' open={open} onClose={this.close}>
                        <Modal.Header>BID LOWEST PRICE</Modal.Header>
                        <Modal.Content>
                            <p>{winningBidAmount ? `You will be the lowest priced bid on this request by placing a bid of ${priceDisplay(winningBidAmount)}.` : `Min and max price for service are not set, please set them first from "Price Update" page.`}</p>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button negative content='Cancel' onClick={this.close} />
                            <Button positive content='Confirm' onClick={this.confirmWinBid} />
                        </Modal.Actions>
                    </Modal>
                    <Modal size='small' open={historyModalOpen} onClose={this.historyModalClose} centered={false} closeIcon >

                        <Modal.Header>QUOTE HISTORY</Modal.Header>
                        <Modal.Content>
                            {/*currentSellerBid &&*/
                                <Segment className="main-segment-style">
                                    <div>
                                        <span style={{ fontWeight: 'bold' }}>Service: </span>
                                        <span>{this.state.currentServiceName}</span>
                                    </div>
                                    <div style={{ paddingTop: '10px' }}>
                                        <span style={{ fontWeight: 'bold' }}>Quick Info: </span>
                                        <span>{this.state.currentQuickInfo}</span>
                                    </div>
                                </Segment>}
                            <div className="top-aligned-modal">
                                <BidHistory bidHistory={bidHistory} userHas2PlaceBid={!currentSellerBid} hideheading={true} />

                            </div>
                            <Grid padded>
                                <Grid.Column width={16} textAlign='right'>
                                    <Button type="button" onClick={this.historyModalClose}>Close</Button>
                                </Grid.Column>
                            </Grid>
                        </Modal.Content>

                    </Modal>
                    <Modal size='small' open={this.state.isMoreInfoModalOpen} onClose={() => this.setState({ isMoreInfoModalOpen: false })} centered={false} >
                        <Modal.Header style={{ fontSize: '14px' }}>Have questions about this request?</Modal.Header>
                        <Modal.Content>
                            <Formsy onValidSubmit={this.onRequetInfoSubmit}>
                                <DGTextarea
                                    name='info-request'
                                    validationErrors={{
                                        isDefaultRequiredValue: 'Please enter some details that you need about this request'
                                    }}
                                    onChange={(e, data) => this.setState({ sellerInfoRequestMessage: data.value })}
                                    required
                                    placeholder='Type any information that you need from customer to place a quote' 
                                    style={{ minHeight: 100, width: '100%', fontSize: '14px', margin: '1rem', minHeight: '100px', padding: '10px', width: 'calc(100% - 2rem)' }} />
                                <Grid padded>
                                    <Grid.Column width={16} textAlign='right'>
                                        <Button primary size='large'>Submit</Button>
                                        <Button size='large' onClick={() => this.setState({ isMoreInfoModalOpen: false })}>Close</Button>
                                    </Grid.Column>
                                </Grid>
                            </Formsy>
                        </Modal.Content>

                    </Modal>
                    { this.state.requestIdForDetails > 0 &&
                        <Modal size="large" className="dgmodal place-bid-modal-new" open={detailsModalOpen} onClose={this.onDetailsModalClose} centered={true} closeIcon>
                            <Modal.Header>
                                Quote Details
                        </Modal.Header>
                            <Modal.Content>
                                <PlaceBidContainerNew isUnAuthorized={this.props.isUnAuthorized} requestId={this.state.requestIdForDetails} afterBidPlaced={this.afterBidPlaced} />
                            </Modal.Content>
                        </Modal>
                    }
                </Card.Content>)
                }
            </Card>
        );
    }
}


const mapStateToProps = ({
    auth: { currentUser },
    notification: { added, updated, lost },
}) => {
    return { currentUser, added, updated, lost };
}

const mapDispatchToProps = {
    showNotificationMessage,
    clearLostNotification,
    refreshSellerServices,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectsBids);